import React, { Component } from "react";
import { FormControl } from '@mui/material';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import Typography from '@mui/material/Typography';
import settings from "../../helpers/Settings";
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Icon } from "@iconify/react";
import { IconButton } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Cookies from "js-cookie";
import RadioGroup from '@mui/material/RadioGroup';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
let { KayanURL } = settings;
class AddEmployee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employeeData: { companyid: this.props.companyId, role:"doctor" },
      role:"doctor"
    };
  }
  componentDidMount = async () => {
    // this.getAllDepartments();
  };
  handleChangeRadioButton = (e) => {
    
    this.setState({ employeeData: { ...this.state.employeeData, role: e.target.value },role:e.target.value });

  }
  HandleEmployeeInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({ employeeData: { ...this.state.employeeData, [name]: value } });
  }
  handelAddEmployee = async (event) => {
    event.preventDefault();
    this.setState({
      employeeResponseReady: false,
      addEmployeeRequestSent: true,
    });
    const result = await axios.post(KayanURL + "api/KSA/RCM/employee/addNewDoctor", {
      data: this.state.employeeData,
      apiToken: Cookies.get("RCM_KSA_Admin_Token"),
    });

    if (result) {
      let { data } = result;
      this.setState({ addEmployeeRequestSent: false, employeeResponseReady: true });
      if (data.success) {
        this.setState({ addEmployeeSuccess: true, addEmployeeMsg: "Employee Added successfully" });
      } else {
        this.setState({ addEmployeeSuccess: false, errorAddEmployee: data.error });
      }
    }
  }
  render() {
    let {
      addEmployeeRequestSent,
      employeeResponseReady,
      addEmployeeSuccess, } = this.state;
    return (
      <>
        <div style={{ width: "90%", margin: "auto", padding: "20px" }}>
          <div>
            <Typography variant="h6" component="div" >
              Add Employee As:
            </Typography>
            <div style={{ margin: "10px auto", textAlign: "center" }}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="doctor"
                  name="radio-buttons-group"
                  onChange={this.handleChangeRadioButton}
                >
                  <div
                    style={{ display: "flex" }}
                  >
                    <FormControlLabel value="doctor" control={<Radio />} label="Doctor" />
                    <FormControlLabel value="receptionist" control={<Radio />} label="Receptionist" />
                    <FormControlLabel value="financial" control={<Radio />} label="Financial" />
                    <FormControlLabel value="nurse" control={<Radio />} label="Nurse" />
                    <FormControlLabel value="super" control={<Radio />} label="Super" />
                  </div>

                </RadioGroup>
              </FormControl>
            </div>
          </div>

          <div style={{ width: "50%", margin: "20px auto" }}>
            <FormControl fullWidth sx={{ mb: 3 }} >
              <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                inputProps={{ sx: { padding: "11px" } }} required
                label="Name" variant="outlined" name="name"
                onChange={this.HandleEmployeeInputTextChange}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 3 }}>
              <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                inputProps={{ sx: { padding: "11px" } }} required
                label="User Name" variant="outlined" name="userName"
                onChange={this.HandleEmployeeInputTextChange}
              />
            </FormControl>
            <FormControl fullWidth sx={{ mb: 3 }}>
              <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                inputProps={{ sx: { padding: "11px" } }} required name="password"
                onChange={this.HandleEmployeeInputTextChange}
                type='password' label="Password" />
            </FormControl>
            {this.state.role == "doctor" ? (<>
              <FormControl fullWidth sx={{ mb: 3 }} >
                <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                  inputProps={{ sx: { padding: "11px" } }} required
                  label="License" variant="outlined" name="license"
                  onChange={this.HandleEmployeeInputTextChange}
                />
              </FormControl>

              <FormControl fullWidth sx={{ mb: 3 }} >
                <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                  inputProps={{ sx: { padding: "11px" } }} required
                  label="Practice Code" variant="outlined" name="practiceCode"
                  onChange={this.HandleEmployeeInputTextChange}
                />
              </FormControl>
            </>) : null}

            <div style={{ textAlign: "center" }}>
              <Button variant="contained" style={{
                backgroundColor: "rgb(61 65 68)",
                height: "35px", width: "30%",
                textTransform: "capitalize", color: "white"
              }}
                onClick={(e) => this.handelAddEmployee(e)}
              > Add
              </Button>
            </div>
            {addEmployeeRequestSent && !employeeResponseReady ? (
              <div style={{ textAlign: "center", marginTop: "10px" }}>
                <Spinner animation="border" variant="success" />
              </div>
            ) : addEmployeeSuccess ? (
              <div style={{ textAlign: "center" }}>
                <h5 style={{
                  color: "green",
                  textAlign: "center",
                  marginTop: "20px"
                }}>{this.state.addEmployeeMsg}</h5>
              </div>
            ) : employeeResponseReady && this.state.errorAddEmployee ? (
              <h5 style={{ color: "red" }}>{this.state.errorAddEmployee}</h5>
            ) : null}

          </div>

        </div>
      </>
    );
  }
}

export default AddEmployee;
